export default {
      id: "icon-anglegray2-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "icons.svg#icon-anglegray2",
      toString: function () {
        return this.url;
      }
    }